import { useState, useEffect } from 'react';
import { LIMITES } from '../../../utils/constantes';

export const useClientIdentificationCardLogic = (setClientData, onTotalIncomeChange) => {

  const [buyers, setBuyers] = useState([{ name: '', income: 0, birthDate: '2000-01-01', cpf: '' }]);
  const [pagadoria, setPagadoria] = useState(false);
  const [valorComissao, setValorComissao] = useState(0);

  const calculateAndSendTotalIncome = (currentBuyers) => {
    if (!onTotalIncomeChange) return;
    const totalIncome = currentBuyers.reduce((sum, buyer) => {
      const incomeValue = buyer.income ? parseFloat(buyer.income.toString().replace(/[^\d.-]/g, '')) : 0;
      return sum + (isNaN(incomeValue) ? 0 : incomeValue);
    }, 0);
    onTotalIncomeChange(totalIncome);
  };

  useEffect(() => {
    if (setClientData) {
      setClientData({
        buyers,
        pagadoria,
        valorComissao,
      });
    }
  }, [
    buyers,
    pagadoria,
    valorComissao,
  ]);

  // Calcular a renda total sempre que houver mudanças nos compradores
  useEffect(() => {
    calculateAndSendTotalIncome(buyers);
  }, [buyers, onTotalIncomeChange]);

  const handleBuyerChange = (index, field, value) => {
    const newBuyers = [...buyers];
    newBuyers[index][field] = value;
    setBuyers(newBuyers);

    // Calcular imediatamente se a renda for alterada
    if (field === 'income') {
      calculateAndSendTotalIncome(newBuyers);
    }
  };

  const handlePagadoriaChange = (e) => {
    setPagadoria(e.target.checked);
    if (!e.target.checked) {
      setValorComissao(0);
    }
  }

  const handleValorComissaoChange = (e) => {
    setValorComissao(e.target.value);
  }

  const addBuyer = () => {
    if (buyers.length < LIMITES.COMPRADORES) {
      const newBuyers = [...buyers, { name: '', income: '', birthDate: '2000-01-01', cpf: '' }];
      setBuyers(newBuyers);
    }
  };

  const removeBuyer = (index) => {
    const newBuyers = buyers.filter((_, i) => i !== index);
    setBuyers(newBuyers);

    calculateAndSendTotalIncome(newBuyers);
  };

  return {
    buyers,
    pagadoria,
    valorComissao,
    handleBuyerChange,
    addBuyer,
    removeBuyer,
    handlePagadoriaChange,
    handleValorComissaoChange
  };
};